import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => {
  return {
    module: {
      marginLeft: '-10px',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flex: 1,
    },
    iOSSwitchBase: {
      '&$iOSChecked': {
        '& + $iOSBar': {
          backgroundColor: '#fff',
          border: '1px solid #8866ff',
        },
      },
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.sharp,
      }),
    },
    iOSChecked: {
      transform: 'translateX(15px)',
      '& + $iOSBar': {
        opacity: 1,
        border: 'none',
      },
    },
    iOSBar: {
      borderRadius: 13,
      width: 40,
      height: 24,
      marginTop: -13,
      marginLeft: -21,
      border: 'solid 1px',
      borderColor: theme.palette.grey[400],
      backgroundColor: `${theme.palette.grey[50]} !important`,
      opacity: '1 !important',
      transition: theme.transitions.create(['background-color', 'border']),
    },
    iOSIcon: {
      width: 16,
      height: 16,
      marginTop: '-2px',
      backgroundColor: '#bbbbbb',
      boxShadow: 'none',
    },
    iOSIconChecked: {
      backgroundColor: '#8866ff',
    },
    content: {
      paddingLeft: 12,
    },
    errorTitle: {
      fontSize: 16,
      fontWeight: 'bold',
      lineHeight: 1.5,
      color: 'rgb(255, 78, 68)',
    },
    ecomErrorsList: {
      listStyleType: 'none',
      fontSize: 10,
      color: 'rgb(255, 78, 68)',
      marginLeft: 55,
      lineHeight: 2,
    },
    linkTroubleshoot: {
      margin: '24px 0 0 55px',
      display: 'inline-block',
      padding: '11px 30px',
      fontSize: 16,
      fontWeight: 500,
      textAlign: 'center',
      color: '#000000',
      borderRadius: 4,
      border: 'solid 1px #ff4e44',
      backgroundColor: '#ffffff',
      transition:
        'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      '&:hover': {
        boxShadow: '0 0 0 1px #ff4e44',
      },
    },
    customDisabled: {},
  }
})
